import React, { useState } from "react";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";

export default function AddDead() {
  const { graveId } = useParams();
  const location = useLocation();
  const [name, setName] = useState("");
  const [burialDate, setBurialDate] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // استرجاع رقم المقبرة من location.state، إذا لم يكن موجودًا نعرض "غير معروف"
  const graveNumber = location.state?.graveNumber || "غير معروف";

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const token = localStorage.getItem("userToken");

      await axios.post(
        `https://cemetery-management.vercel.app/api/graves/${graveId}/bury`,
        {
          name,
          burialDate,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSuccessMessage("تمت عملية الدفن بنجاح!");
      setErrorMessage("");
      setName(""); // إعادة تعيين الاسم
      setBurialDate(""); // إعادة تعيين تاريخ الدفن
    } catch (error) {
      console.error("Error:", error);
      setErrorMessage("حدث خطأ أثناء حفظ البيانات");
      setSuccessMessage("");
    }
  };

  return (
    <div className="add-dead-container container p-5">
      <h2>دفن شخص جديد في مقبرة رقم {graveNumber}</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="name">اسم المتوفى:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="burialDate">تاريخ الدفن:</label>
          <input
            type="date"
            id="burialDate"
            name="burialDate"
            value={burialDate}
            onChange={(e) => setBurialDate(e.target.value)}
            required
          />
        </div>
        <button type="submit">حفظ</button>
      </form>

      {successMessage && <p style={{ color: "green" }}>{successMessage}</p>}
      {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
    </div>
  );
}
